import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'

import { Toaster } from '@leanpay/ui'

import AppStore from './app-store'

import MainLayout from './main-layout'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <Toaster />
            <BrowserRouter>
                <AppStore>
                    <MainLayout />
                </AppStore>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}

export default App
